import { useQuery } from 'react-query';
import { queryKeys } from './queryKeys';
import { client } from '../../../actions';
import { authHeader } from '../../../helpers/auth-header';

const getDocumentReminderOptions = async () => {
  const response = await client.get('docs/notification_type', {
    headers: authHeader(),
  });
  return response.data;
};

export const useDocumentReminderOptionsQuery = (options = {}) => {
  return useQuery(
    queryKeys.documentReminderOptions,
    () => getDocumentReminderOptions(),
    {
      placeholderData: [],
      staleTime: Infinity,
      ...options,
    }
  );
};
